import React from "react";
import {Link } from "react-router-dom";
import './ButtonWhite.css';
function ButtonWhite(props) {return (
    <Link to={props.ssilka} ><div className={props.classname}><nobr>{props.label}</nobr></div></Link>
)}

export default ButtonWhite